/**
 * 网络请求封装，支持全局配置，也支持每个方法自定义配置
 */
import axios from 'axios'
import store from '@/store'
import defaultConfig from './config' // 默认配置
import qs from 'qs'
import { refreshToken } from '@/api/common'
import router from '@/router'
import * as common from '@/utils/utils'
import sysConfig from '@/config'
// 取消网络请求
// const TIMEOUT = 30 * 1000 // ajax超时时间

// 排序
const compare = data => {
  const params = {}
  Object.keys(data).sort().forEach((key) => {
    params[key] = data[key]
  })
  return params
}


let isRefreshing = false
let retryRequests = []

// 初始化axios实例
const instance = axios.create({
  ...defaultConfig
})
instance.defaults.retry = 4 // 请求次数
instance.defaults.retryDelay = 1000 // 请求间隙

// 请求拦截器
instance.interceptors.request.use(config => {
  if (localStorage.getItem('access_token')) {
    config.headers.Authorization = localStorage.getItem('access_token')
  }
  // 鉴权的统一参数 data
  const commonData = {
    timestamp: common.getTimeByTimeZone(new Date().getTime(), 8).getTime(),
    appId: sysConfig.APP.APP_KEY,
    nonce: common.md5Encrypt(`${common.getTimeByTimeZone(new Date().getTime(), 8).getTime()}${common.randomString(10)}`)
  }
  // 如果是post要变成parse
  if (config.method === 'post') {
    // { ...qs.parse(config.data), ...commonData }
    const data = compare(Object.assign(commonData, qs.parse(config.data))) // 原始数据
    if (config.url.indexOf('/bm/studentHistoryImport') == -1) {
      if (data.sign) delete data.sign
      const signData = {
        ...data,
        secret: sysConfig.APP.APP_SECRET
      }
      const newSignData = JSON.parse(JSON.stringify(signData))
      Object.keys(newSignData).forEach(item => {
        if (newSignData[item] === '') delete newSignData[item]
      })
      const sign = Array.from(Object.keys(newSignData)).map(v => {
        return `${v}=${newSignData[v]}`
      })
      const configData = {
        ...data,
        sign: common.sha256Encrypt(sign.join('&')).toUpperCase()
      }
      config.data = qs.stringify({ ...configData })
    } else {
      console.log(111)
      const configData = {
        ...data,
        sign: '1ea138354601a0168d77d949567e2f16'
      }
      config.data = qs.stringify({ ...configData })
    }
    // console.log(config.data)
  } else if (config.method === 'get') {
    const params = compare(Object.assign(commonData, config.params))
    if (params.sign) delete params.sign
    const signData = {
      ...params,
      secret: sysConfig.APP.APP_SECRET
    }
    const newSignData = JSON.parse(JSON.stringify(signData))
    Object.keys(newSignData).forEach(item => {
      if (newSignData[item] === '') delete newSignData[item]
    })
    config.params = Object.assign(params, {
      sign: common.sha256Encrypt(qs.stringify(newSignData)).toUpperCase()
    })
  }
  // 如果是ie浏览器，需强制请求，不然会读取缓存
  // if (browser('ie') && config.method === 'get') {
  //   config.headers['If-Modified-Since'] = '0'
  // }
  return Promise.resolve(config)
}, error => {
  return Promise.reject(error)
})

// response 拦截器
instance.interceptors.response.use(
  async res => {
    switch (res.data.status) {
      case 200:
        return Promise.resolve(res)
      case 401: {
        // token失效
        const config = res.config
        if (!isRefreshing) {
          isRefreshing = true
          return refreshToken().then(ress => {
            console.log(ress, '------------res')
            if (ress.data.status === 1) {
              console.log('store=>', store, ress.data.data.access_token)
              localStorage.setItem('access_token', ress.data.data.access_token)
              // 设置token
              config.headers.Authorization = ress.data.data.access_token
              // 已经刷新了token，将所有队列中的请求进行重试
              retryRequests.forEach(cb => cb(ress.data.data.access_token))
              // 重试完清空这个队列
              retryRequests = []
              return instance(config)
            }
          }).catch(err => {
            // Message.error('请求失败!')
            console.log('tag', err)
          }).finally(() => {
            isRefreshing = false
          })
        } else {
          // 正在刷新token，返回一个未执行resolve的promise
          return new Promise(resolve => {
            // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
            // @ts-ignore
            retryRequests.push(token => {
              // config.baseURL = ''
              config.headers.Authorization = token
              // config.headers['adminToken'] = localStorage.getItem('adminToken')
              // console.log(config)
              resolve(instance(config))
            })
          })
        }
      }
      case 20001:
        return Promise.reject(res)
      case 20002:
        return Promise.reject(res)
      case 20004:
        return Promise.reject(res)
      case 4011:
      case 400001:
        console.log('异常跳转')
        localStorage.removeItem('access_token')
        localStorage.removeItem('userInfo')
        router.replace('/login')
        // alert('会话已失效，请重新登录操作')
        window.location.reload()
        return Promise.reject(res)
      default:
        return Promise.resolve(res)
    }
  }, async err => {
    console.log('err---' + err)
    // 请求超时， 重新请求
    var config = err.config
    if (!config || !config.retry) return Promise.reject(err)

    config.__retryCount = config.__retryCount || 0

    if (config.__retryCount >= config.retry) {
      return Promise.reject(err)
    }

    config.__retryCount += 1

    const backoff = new Promise(function(resolve) {
      setTimeout(function() {
        resolve()
      }, config.retryDelay || 1)
    })

    // Message.error('请求超时，正在重连...')
    await backoff
    return instance(config)
  }
)
export default {
  async get(url, params, config = {}) {
    const res = await instance.get(url, { params }, config)
    return res
  },
  async post(url, params = {}, config = {}) {
    const res = await instance.post(url, qs.stringify({ ...params }), config)
    return res
  },
  async post1(url, params = {}, config = {}) {
    const res = await instance.post(url, JSON.stringify(params), config)
    // temp.remove()
    return res
  },
  async postData(url, blobInfo, config = {}) {
    const param = new FormData() // 创建form对象
    for (const key in blobInfo) {
      param.append(key, blobInfo[key])
    }
    return await instance.request({
      method: 'post',
      url: url,
      data: param,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).finally(res => {
      Promise.resolve(res)
    })
  },
  delete(url, param, config = {}) {
    return new Promise((resolve, reject) => {
      (
        {
          method: 'delete',
          url,
          params: param,
          ...config
        }
      )
    })
  }
}
